var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.711,
    height: 18.505,
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    stroke: "#000",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 32",
    transform: "translate(-947.644 -530)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    "data-name": "Ellipse 35",
    transform: "translate(953.343 530.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    "data-name": "Ellipse 36",
    transform: "translate(954.343 531.5)"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.512 17.505a8.29 8.29 0 00-16.312 0z",
    "data-name": "Path 222"
  }))));
};
export default SvgProfile;